<script>
import { mapGetters, mapActions } from 'vuex'
import { getUserToken } from '../api'
import toastMethods from '../mixins/toastMethods'
import loginData from '../mixins/loginData'

export default {
  mixins: [
    toastMethods,
    loginData
  ],
  computed: mapGetters([
    'initial'
  ]),
  data () {
    return {
      initiated: false
    }
  },
  created () {
    if (this.initial !== null) {
      this.fetch(this.initial)
    }
  },
  watch: {
    '$route' () {
      if (this.initial !== null) {
        this.fetch(this.initial)
      }
    },
    'initial' (value) {
      if (this.initial !== null) {
        this.fetch(this.initial)
      }
    }
  },
  methods: {
    ...mapActions([
      'setLoadingAction',
      'setDialogLoadingAction'
    ]),
    async fetch (initial) {
      let routeName = this.$route.name
      try {
        this.setLoadingAction(true)
        if (this.preSetData) {
          await this.preSetData()
        }
        if (this.fetchDataGuest) {
          await this.fetchDataGuest()
        }
        if (initial && this.fetchData) {
          await this.fetchData()
        }
        if (this.afterSetData) {
          await this.afterSetData()
        }
        this.setLoadingAction(false)
        this.initiated = true
      } catch (error) {
        const isListEmptyMessages = [
        ]
        const isListEmptyError = msg => isListEmptyMessages.includes(msg)
        const defaultActionAlert = (data) => {
          let msg = data.result.message || this.$t('MIXIN.routeLoading.___noPermission')
          this.addToast('error', msg)
        }
        const customActions = [
          {
            status: 401,
            path: '/cases',
            alert: () => {
              defaultActionAlert()
              this.setUserData(null)
            }
          }
        ]
        let action = customActions.find(x =>
          (!x.name || (error.message && x.name === error.message)) &&
          (!x.api || (error.request && new RegExp(x.api).test(error.request.responseURL))) &&
          (!x.status || (error.response && x.status === error.response.status)) &&
          (!x.path || new RegExp(x.path).test(this.$route.fullPath))
        )
        if (this.$route.name === routeName) {
          if (action) {
            let redirect = action.alert ? action.alert() : defaultActionAlert()
            this.setLoadingAction(false)
            this.setDialogLoadingAction(false)
            this.$router.push(redirect || { name: 'user' })
          } else if (error.response && !isListEmptyError(error.response.data.result.message)) {
            defaultActionAlert(error.response.data)
            this.setLoadingAction(false)
            this.setDialogLoadingAction(false)
            try {
              let config = this.$ls.get('userInfo')
              await getUserToken(config)
            } catch (error) {
              this.setUserData(null)
            }
            this.$router.push({ name: 'user' })
          } else {
            console.error(error)
            this.setLoadingAction(false)
            this.setDialogLoadingAction(false)
          }
        } else {
          this.setLoadingAction(false)
          this.setDialogLoadingAction(false)
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/mixins/routeLoading.vue